<!-- 结算流程 -->
<template>
  <div class="basicStyle">
    <div class="settlementBox">
      <div class="settlementLeft">
        <div class="left_title">
          <h3>请确认收款账户信息</h3>
          <p>
            为保证账户资金安全及后续结算，请先完成收款账户确认（一经确认无法修改），未确认将无法进行结算。
          </p>
        </div>
        <div class="left_cont">
          <el-form
            ref="bankData"
            :model="bankData"
            :inline="true"
            label-width="0"
          >
            <div class="filter-item ml-3">
              <label class="classLabel">账户名称</label>
              <el-form-item>
                <el-input
                  v-model="bankData.bank_account"
                  style="width: 300px"
                  class="filter-input"
                  placeholder="请输入帐号名称"
                  :disabled="bankData.is_bank_check != 0"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="filter-item ml-3">
              <label class="classLabel">开户行</label>
              <el-form-item>
                <el-input
                  v-model="bankData.bank_address"
                  style="width: 300px"
                  class="filter-input"
                  placeholder="请输入开户行名称"
                  :disabled="bankData.is_bank_check != 0"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="filter-item ml-3">
              <label class="classLabel">银行卡号</label>
              <el-form-item>
                <el-input
                  v-model="bankData.bank_number"
                  style="width: 300px"
                  class="filter-input"
                  placeholder="请输入卡号"
                  :disabled="bankData.is_bank_check != 0"
                  clearable
                />
              </el-form-item>
            </div>
            <div class="filter-item ml-3" style="text-align: center">
              <el-button
                v-if="bankData.is_bank_check == 2"
                class="confirmBtn"
                type="info"
                disabled
                >已完成帐号确认~</el-button
              >

              <el-button
                v-if="bankData.is_bank_check == 1"
                class="confirmBtn"
                type="danger"
                @click="wrongAccount()"
              >
                <div>
                  账号不对
                  <!-- 
                </div>
                <div> -->
                  （请联系对接人员）
                </div>
              </el-button>
              <el-button
                v-if="bankData.is_bank_check == 1"
                class="confirmBtn"
                type="danger"
                @click="savePoster()"
                >确认无误</el-button
              >

              <el-button
                v-if="bankData.is_bank_check == 0"
                class="confirmBtn"
                type="danger"
                @click="tobBankSave()"
                >确认无误</el-button
              >
            </div>
          </el-form>
        </div>
      </div>
      <div class="settlementRight">
        <iframe
          :src="firstSrc"
          :width="firstWidth"
          :height="firstHeight"
          frameborder="0"
          allowfullscreen
        />
      </div>
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
// 结算流程
export default {
  name: "settlementProcess",
  components: { MyButton },
  data() {
    return {
      firstSrc: "",
      firstWidth: "100%",
      firstHeight: "800px",
      bankData: {},
    };
  },
  computed: {},
  created() {
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV === "development") {
      this.firstSrc =
        "http://testLavaMobile.qbting.com/testtask/#/web?key=beikaotongSettlementinstructions&apptype=beikaotong";
    } else {
      this.firstSrc =
        "http://qmb.meite.com/task/#/web?key=beikaotongSettlementinstructions&apptype=beikaotong";
    }

    this.getTobMarketing();
  },
  methods: {
    wrongAccount() {
      // 账号不对
      this.$message.error("请联系对接人员进行修改!");
    },
    tobBankSave() {
      //   确认无误;
      console.log("this.bankData", this.bankData);
      if (
        !this.bankData.bank_account ||
        !this.bankData.bank_address ||
        !this.bankData.bank_number
      ) {
        this.$message({
          message: "存在必填项未填",
          type: "error",
        });
        return;
      }
      this.$confirm("是否完成确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        commonApi
          .tobBankSave({
            bank_account: this.bankData.bank_account,
            bank_address: this.bankData.bank_address,
            bank_number: this.bankData.bank_number,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "确认无误!",
              });
              this.$router.push({
                path: "/tobSettlement",
              });
            } else {
              this.$message.error(res.message);
            }
          });
      });
    },
    async savePoster() {
      //   确认无误;
      this.$confirm("是否完成确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        commonApi.tobBankConfirm().then((res) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "确认无误!",
            });
            this.$router.push({
              path: "/tobSettlement",
            });
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    async getTobMarketing() {
      const res = await commonApi.getTobMarketing();
      if (res.code == 200) {
        console.log("getTobMarketing", res.data);
        this.bankData = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  //   .table {
  //     min-height: calc(100vh - 330px);
  //     border: 1px solid #ddd;
  //     border-radius: 10px;
  //     .studentLabel {
  //       display: inline-block;
  //       padding: 5px 10px;
  //       background-color: #409eff;
  //       color: #fff;
  //       border-radius: 4px;
  //       margin: 0 5px 5px 0;
  //     }
  //   }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin: 10px;
  display: flex;
  justify-content: space-around;
  height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}
.activeNumber {
  color: #f40;
}
.item_a1 {
  background-color: #f5f3ff;
}
.item_a2 {
  background-color: #edfffa;
}
.item_a3 {
  background-color: #fff6ed;
}
.item_a4 {
  background-color: #ffefef;
}
/deep/.el-dialog__footer {
  text-align: center;
}

.initialLogin {
  background: #ffebeb;
  border-radius: 8px 8px 8px 8px;
  line-height: 45px;
  padding: 0 20px 0 16px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
  .initialLeft {
    color: #191b27;
    font-size: 15px;
    font-weight: 500;
  }
  .initialRight {
    height: 32px;
    width: 72px;
    background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    line-height: 32px;
    text-align: center;
    font-size: 13px;
    color: #ffffff;
    cursor: pointer;
  }
}

.settlementBox {
  display: flex;
  justify-content: space-around;
  padding: 20px;
  .settlementLeft {
    width: 50%;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    .left_title {
      h3 {
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }
  .settlementRight {
    width: 40%;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
  }
}
/deep/.left_cont {
  padding-top: 20px;
  .filter-item {
    display: block;
    margin: 0;
    vertical-align: top;
    padding-left: 40px;
    .classLabel {
      text-align: left;
      font-size: 15px;
      font-weight: 500;
      color: #000;
      margin-right: 20px;
      line-height: 40px;
      width: 65px;
      display: inline-block;
    }
  }
}
.confirmBtn {
  display: inline-block;
  margin: 0 auto;
  vertical-align: middle;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
